import type { Weapon } from "./Weapon.type"

export default function decrementAmmo(weapon: Weapon) {
  const { ammops } = weapon
  if (ammops) {
    weapon.ammo = (weapon.ammo ?? 0) - ammops
  }
}